import React, { Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { Provider } from 'react-redux';
import firebaseTools from 'utils/firebase/tools.firebase';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import createRoutes from './router';
import configureStore from './utils/configureStore';

// Configure the Redux store. Rehydration from localStorage is synchronous
// (see configureStore.js/localStoragePersistence.js) and already complete by
// the time this returns - no loading gate needed before rendering.
const { store } = configureStore();

// Set up Firebase with the store
firebaseTools.setStore(store);

// Loading fallback component
const LoadingFallback = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <CircularProgress size={60} />
    </Box>
  );
};

/**
 * Main application component
 * Provides the Redux store and routing to the application
 */
function AppRoot() {
  // Create the routes with access to the store
  const routes = createRoutes(store);

  return (
    <Provider store={store}>
      <Suspense fallback={<LoadingFallback />}>{routes}</Suspense>
    </Provider>
  );
}

// 3️⃣ Router singleton created
const router = createBrowserRouter([{ path: '*', element: <AppRoot /> }]);

// 4️⃣ RouterProvider added
function App() {
  return <RouterProvider router={router} />;
}

export default App;
